import React, { useRef } from "react";
import _ from "lodash";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button
} from "reactstrap";
// core components

import LoadingIndicator from "../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import * as Helper from "../../utils/Helper";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../redux/screens/chinesepark/EditRoomMemberRedux";
import AuthorizedScreen from "../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../navigation";
import UIDs from "../../UIDs";

const uid = UIDs.screens.chinesepark.editroommember;

class EditRoomMemberScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_STUDENT_ASYNC]: { done: this._handleSaveStudentAsyncDone, error: this._handleAsyncActionError }
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id, classId, roomId } = this.localVars.navParams;
        this.props.createStudent(classId, roomId);
    }

    render() {
        const { student } = this.props.localState;

        return (
            <>
                <Container className="mt--7 aic-list-style" fluid>
                    <Row>
                        <div className="col">
                            {!student || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                                ? <LoadingIndicator />
                                : <EditForm
                                    {...this.props}
                                    student={student}
                                    onCancel={this._handleCancelEdit}
                                    onSave={this._handleSaveStudent}
                                    isDisabled={this.isActionExecuting(ActionTypes.SAVE_STUDENT_ASYNC)}
                                />
                            }
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleSaveStudent = (data) => {
        if(data.reportEmails){
            let newArr = data.reportEmails.split("\n");
            var myreg = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
            let emailSet = new Set();
            for (var i = 0; i < newArr.length; i++) {
                if (newArr[i]) {
                    if (!myreg.test(newArr[i].trim())) {
                        this.displayError({ message: newArr[i] + this.props.t("invalidEmailAddress") });
                        return false;
                    }
                    if (emailSet.has(newArr[i].trim())) {
                        this.displayError({ message: this.props.t("duplicateEmail", { email: newArr[i] }) });
                        return;
                    }
                    emailSet.add(newArr[i].trim());
                }
            }
            if(emailSet)
                data.reportEmails = _.join(Array.from(emailSet), ";");
        }

        //AIC-9-299 检验邮箱允许多余的空格，所以插入数据之前去掉email和familyEmail的多余空格
        data.email = data.email.trim();
        if (data.familyEmail)
            data.familyEmail = data.familyEmail.trim();
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        this.props.saveStudentAsync(data);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleCancelEdit = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleSaveStudentAsyncDone = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }
}

function EditForm(props) {
    const { student } = props;
    const { id, classId, userId, studentName, email, familyEmail, phone, reportEmails, roomId } = student;
    const { register, handleSubmit, errors, clearError } = useForm();
    const submitRef = useRef();

    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        <span className="titleLabel">{props.t("student")}</span>
                    </Col>
                    <Col className="text-right" xs="4">
                        <Button
                            color="info"
                            onClick={() => submitRef.current.click()}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("save")}
                        </Button>&nbsp;
                        <Button
                            color="default"
                            onClick={props.onCancel}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("cancel")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <input name="id" hidden type="text" className="form-control" defaultValue={id} ref={register} />
                    <input name="classId" hidden type="text" className="form-control" defaultValue={classId} ref={register} />
                    <input name="roomId" hidden type="text" className="form-control" defaultValue={roomId} ref={register} />
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("studentName")}</label>
                                    <input name="studentName" type="text" className="form-control-alternative form-control" defaultValue={studentName}
                                        ref={register({
                                            required: props.t("fieldIsRequired"),
                                            validate: {
                                                message: value => {
                                                    if (value.length > 20) {
                                                        return props.t("invalidLength", { max: 20 });
                                                    }
                                                    return clearError();
                                                }
                                            }
                                        })} />
                                    {errors.studentName && <span className="text-danger">{errors.studentName.message}</span>}                                   
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("phone")}</label>
                                    <input name="phone" type="text" className="form-control-alternative form-control" defaultValue={phone}
                                        ref={register({
                                            pattern: {
                                                value: /^[0-9-]{7,}$/,
                                                message: props.t("invalidPhone"),
                                            },
                                            validate: {
                                                message: value => {
                                                    if (value.length > 20) {
                                                        return props.t("invalidLength", { max: 20 });
                                                    }else if(value.indexOf("--")!=-1){
                                                        return props.t("invalidPhone");
                                                    }else if(value.charAt(value.length -1) === "-"){
                                                        return props.t("invalidPhone");
                                                    }else if(value.charAt(0) === "-"){
                                                        return props.t("invalidPhone");
                                                    }
                                                    return clearError();
                                                }
                                            }
                                        })} />
                                    {errors.phone && <span className="text-danger">{errors.phone.message}</span>}                                    
                                </div>
                            </div>                            
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("email")}</label>
                                    <input name="email" type="text" disabled={!!userId} className="form-control-alternative form-control" defaultValue={email}
                                        ref={register({
                                            required: props.t("fieldIsRequired"),
                                            validate: {
                                                message: value => {
                                                    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value.trim())) {
                                                        return props.t("invalidEmailAddress");
                                                    }
                                                    if (value.trim().length > 50) {
                                                        return props.t("invalidLength", { max: 50 });
                                                    }
                                                    return clearError();
                                                }
                                            }
                                        })} />
                                    {errors.email && <span className="text-danger">{errors.email.message}</span>}
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-group">
                                    {
                                        Helper.isNullOrEmpty(userId) ?
                                        <>
                                            <label className="form-control-label">{props.t("familyEmail")}</label>
                                            <input name="familyEmail" type="text" className="form-control-alternative form-control" defaultValue={familyEmail}
                                                ref={register({
                                                    // pattern: {
                                                    //     value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                    //     message: props.t("invalidEmailAddress")
                                                    // },
                                                    validate: {
                                                        message: value => {
                                                            if (value) {
                                                                if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value.trim())) {
                                                                    return props.t("invalidEmailAddress");
                                                                }
                                                                if (value.trim().length > 50) {
                                                                    return props.t("invalidLength", { max: 50 });
                                                                }
                                                                return clearError();
                                                            }
                                                        }
                                                    }
                                                })} />
                                            {errors.familyEmail && <span className="text-danger">{errors.familyEmail.message}</span>}
                                        </>
                                        :
                                        <>
                                            <label className="form-control-label">{props.t("reportEmails")}</label>
                                            <input name="familyEmail" type="hidden" value={familyEmail} ref={register()} />
                                            <textarea className="form-control-alternative form-control" rows={4} name="reportEmails"
                                                ref={register()}
                                            >{Helper.isNullOrEmpty(reportEmails) ? null : _.join(reportEmails.split(";"), "\n")}</textarea>
                                        </>
                                    }
                                </div>
                            </div>                            
                        </div>                        
                    </div>
                    <input ref={submitRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: id => dispatch(Actions.loadScreenViewAsync(id)),
        saveStudentAsync: vo => dispatch(Actions.saveStudentAsync(vo)),
        createStudent: (classId, roomId) => dispatch(Actions.createStudent(classId, roomId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditRoomMemberScreen));